import React from 'react';
import { Shield, Clock, ThumbsUp, Users } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: Shield,
    title: 'Qualified Engineers',
    description: 'All technicians fully trained'
  }, {
    icon: Clock,
    title: 'Fast Response',
    description: 'Typically within 48 hours'
  }, {
    icon: ThumbsUp,
    title: 'Clear Pricing',
    description: 'No hidden fees'
  }, {
    icon: Users,
    title: 'UK-Based Support',
    description: 'Friendly local service'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-365">
      <div className="max-w-7xl mx-auto px-4" data-id="element-366">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-367">
          {badges.map((badge, index) => <div key={index} className="text-center" data-id="element-368">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0D7377] bg-opacity-10 rounded-full mb-4" data-id="element-369">
                <badge.icon className="text-[#0D7377]" size={28} data-id="element-370" />
              </div>
              <h3 className="font-semibold text-lg mb-2 text-gray-900" data-id="element-371">
                {badge.title}
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-372">{badge.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}